import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class DataService {
  /*Import Customer Excel*/
  haveAttachFile = new Subject<boolean>();
  haveErrorResult = new Subject<boolean>();
  downFile = new Subject<boolean>();
  imported =  new Subject<boolean>();

  closeDialogOutOfContractQuantity =  new Subject<boolean>();

  constructor() {
  }

  setCloseDialogOutOfContractQuantity(result: boolean) {
    this.closeDialogOutOfContractQuantity.next(result);
  }

  setImported(result: boolean) {
    this.imported.next(result);
  }

  setHaveErrorResult(result: boolean) {
    this.haveErrorResult.next(result);
  }

  setHaveAttachFile(result: boolean) {
    this.haveAttachFile.next(result);
  }

  setDownFile(result: boolean) {
    this.downFile.next(result);
  }
}
